<template>
  <div class="quick-actions-grid">
    <div
      v-for="action in actions"
      :key="action.id"
      :class="'qa-item'+ action.id"
      class="qa-item"
      @click="$emit('select', action)"
    >
      <div class="qa-icon" :class="'qa-icon--' + action.color">
        <f7-icon :f7="action.icon" size="18" />
      </div>
      <div class="qa-label">{{ action.label }}</div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  actions: { type: Array, default: () => [] },
})

defineEmits(['select'])
</script>

<style scoped>
.quick-actions-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 16px;
}
.qa-item {
  text-align: center;
  padding: 10px 4px;
  border-radius: 12px;
  background: var(--f7-card-bg-color, #ffffff);
  border: 1px solid var(--f7-list-item-border-color, rgba(111, 122, 113, 0.12));
  box-shadow: 0 2px 8px -2px rgba(26, 107, 66, 0.05);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}
.qa-item:active {
  transform: scale(0.96);
  background: var(--avocash-surface-container-low, #edf6ed);
}
.qa-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 6px;
  transition: background-color 0.2s;
}
.qa-icon--green {
  background: color-mix(in srgb, var(--f7-theme-color, #1A6B42) 12%, var(--f7-card-bg-color, #fff));
  color: var(--f7-theme-color, #1A6B42);
}
.qa-icon--blue {
  background: var(--avocash-blue-light, #EBF0FC);
  color: var(--f7-blue, #3B4FCA);
}
.qa-icon--purple {
  background: var(--avocash-purple-light, #F5F0FF);
  color: var(--f7-purple, #6B46C1);
}
.qa-icon--gold {
  background: var(--avocash-gold-light, #FDF6E3);
  color: var(--f7-secondary, #755B00);
}
.qa-label {
  font-family: var(--avocash-font-body, 'Work Sans', sans-serif);
  font-size: 11px;
  font-weight: 600;
  color: var(--f7-on-surface, #161d18);
  line-height: 1.2;
}
</style>